import { forwardRef } from 'react';

import { twMerge } from 'tailwind-merge';

import { LoaderRef, LoaderWithProgress } from '../../../Loader';

interface ImageUploadInputLoaderProps {
  readonly className?: string;
  readonly value?: number;
}

const ImageUploadInputLoader = forwardRef<LoaderRef, ImageUploadInputLoaderProps>(({ value, className }, ref) => {
  return (
    <div className={twMerge('absolute left-0 top-0 flex h-full w-full items-center justify-center bg-black/40', className)}>
      <LoaderWithProgress ref={ref} type="radial" color="text-white" trackColor="text-white/20" useLabel value={value} />
    </div>
  );
});

export { ImageUploadInputLoader };
